import React from "react";
import Parent from "./component/parent.jsx";
const App = () =>{
  return (
    <div>
       <Parent />
    </div>
  )
}

export default App